export default __webpack_public_path__ + "static/media/category-10.736f9fe0.jpg";